(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/location-name-error-dialog.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/location-name-error-dialog.js');

'use strict';

const {
  getDefaultLocationName
} = svs.tur.lyckoplatsen.utils;
function locationNameErrorDialog() {
  const title = 'Ett fel inträffade gällande platsnamnet';
  const message = "Vi fick ett ov\xE4ntat fel vid h\xE4mtning av platsens namn. <br /> Platsen heter tillf\xE4lligt <strong>".concat(getDefaultLocationName(), "</strong> ");
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: message
    }],
    actions: [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
      }
    }]
  }));
}
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  locationNameErrorDialog
});

 })(window);